export const shouldShowHeaderNavigationForV2 = (path: string) =>
  !path.startsWith('/v1') && !path.endsWith('/legacy-export');
